import { connect } from 'react-redux'
import MaintenanceAuditAppendModifyComponent from '../components/MaintenanceAuditAppendModifyComponent.jsx';
import {
    clean,
	forwardToFindCategories,
	// 結尾加2為將「維修增補項目」改為「檢點增補項目」的程式
	// copy from MaintenanceAppendModifyContainer 再調整
	forwardToFindDetails2,
	forwardToDeleteAppendDetail2,
	forwardToShowMaintenanceModifyComponentModal2,
	forwardToHideMaintenanceModifyComponentModal2,
	forwardToAssignAppendCheckSet2,
	forwardToAssignAppendCheckItem2,
	forwardToAssignAppendCheckNote2,
	forwardToAppendMissingDamageCheckDetail2

} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceAuditingReducer', 'request']),
	response: state.getIn(['maintenanceAuditingReducer', 'response']),
	options: state.getIn(['maintenanceAuditingReducer', 'options']),

	categories: state.getIn(['checkCardReducer', 'view', 'categories']),
})

const mapDispatchToProps = (dispatch) => ({

	findDetails: (card) => {
		dispatch(forwardToFindDetails2(card));
		clean(dispatch);
	},

	deleteDetail: (detail, card) => {
		dispatch(forwardToDeleteAppendDetail2(detail, card));
		clean(dispatch);
	},

	findCategories: () => {
		dispatch(forwardToFindCategories());
	},

	showAppendModal: (card, category) => {
		dispatch(forwardToShowMaintenanceModifyComponentModal2(card, category));
	},
	hideAppendModal: () => {
		dispatch(forwardToHideMaintenanceModifyComponentModal2());
	},

	assignAppendSet: (checkSet) => {
		dispatch(forwardToAssignAppendCheckSet2(checkSet));
	},

	assignAppendItem: (checkItem) => {
		dispatch(forwardToAssignAppendCheckItem2(checkItem));
	},

	assignAppendNote: (note) => {
		dispatch(forwardToAssignAppendCheckNote2(note));
	},

	appendCheckDetail: (editing) => {
		dispatch(forwardToAppendMissingDamageCheckDetail2(editing));
	}
})

const MaintenanceAuditAppendModifyContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceAuditAppendModifyComponent)

export default MaintenanceAuditAppendModifyContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceAuditAppendModifyContainer.jsx